import { STATUS } from 'straightline-utils/constants';
import { yup } from 'straightline-utils/validation';

export default (app) => {
  return yup.object({
    reference_number: yup
      .string()
      .trim()
      .transform((value) => {
        if (!value || value.length <= 255) {
          return value;
        }
        return `${value.slice(0, 252)}...`;
      })
      .nullable()
      .label('Reference Number'),
    status_type: yup
      .string()
      .trim()
      .oneOf(Object.values(STATUS))
      .label('Status')
  });
};
